import { api, REFRESH_URL } from '$lib/utils/api';
import { endServerSession } from '$lib/utils/session';
import { transcriptionStore } from '../transcription/components/transcriptionStore';
import { token, user } from './authStore';

export const getMe = () => api().get('v2/user/me');

// expectedUserId: re-authentication, the server refuses any other user
export const signIn = (email, password, yubikey, expectedUserId) =>
  api().post('nurse/login', { email, password, yubikey, expectedUserId });

// BankID authentication
export const bankIdAuth = () => api().post('nurse/bankid/auth');
export const bankIdCollect = (orderRef, expectedUserId) =>
  api().post('nurse/bankid/collect', { orderRef, expectedUserId });

export const logout = async () => {
  user.set(null);
  token.set(null);
  transcriptionStore.set(null);
  await endServerSession({
    refreshUrl: REFRESH_URL,
    fetchFn: (...args) => fetch(...args),
  });
};

export const sendResetPassword = (email) =>
  api().post('nurse/resetPassword', { email });
export const updatePassword = (userId, password, resetPasswordToken) =>
  api().post('nurse/resetPassword/new', {
    userId,
    password,
    resetPasswordToken,
  });

let hadToken = false;
token.subscribe(async (value) => {
  const sessionStarted = !!value && !hadToken;
  hadToken = !!value;
  if (sessionStarted) {
    getMe()
      .then((data) => {
        data && user.set(data);
      })
      .catch((err) => {
        if (err?.error !== 'Unauthorized') throw err;
      });
  }
});
